import { useState, useRef, useEffect } from "react";
import { getEmployeesAsync } from "actions/Employees";

export const useEmployeesAsync = (
  filteredValue,
  isOnClose,
  setOnClose,
  setSelectedRowsToDelete,
  setEmpList
) => {
  const [employeesData, setEmployeesData] = useState([]);
  const [isEmployeesLoading, setIsEmployeesLoading] = useState(false);
  const [focus, setFocus] = useState(false);
  const debounceTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const lastQueryRef = useRef(null);

  const isOnCloseRef = useRef(isOnClose);
  useEffect(() => {
    isOnCloseRef.current = isOnClose;
  }, [isOnClose]);

  const filteredValueRef = useRef(filteredValue);
  useEffect(() => {
    filteredValueRef.current = filteredValue;
  }, [filteredValue]);

  const fetchEmployees = async (query) => {
    if (debounceTimer.current) clearTimeout(debounceTimer.current);

    return new Promise((resolve) => {
      debounceTimer.current = setTimeout(async () => {
        query.search = query.search || "";
        lastQueryRef.current = query;
        setIsEmployeesLoading(true);
        setEmpList(query);
        setFocus(query.search?.length > 0);

        if (isOnCloseRef.current) {
          setSelectedRowsToDelete([]);
          setOnClose(false);
        }

        const resp = await getEmployeesAsync(query, filteredValueRef.current);
        setEmployeesData(resp?.data ?? []);
        setIsEmployeesLoading(false);
        resolve(resp?.data ?? []);
      }, 300);
    });
  };

  // re-fetch using the last query params without debounce
  const refetchEmployees = async () => {
    if (!lastQueryRef.current) return;
    setEmployeesData([]);
    setIsEmployeesLoading(true);
    const resp = await getEmployeesAsync(
      lastQueryRef.current,
      filteredValueRef.current
    );
    setEmployeesData(resp?.data ?? []);
    setIsEmployeesLoading(false);
  };

  return {
    fetchEmployees,
    refetchEmployees,
    employeesData,
    isEmployeesLoading,
    setIsEmployeesLoading,
    focus,
    setFocus,
  };
};
